/**
 * Adheridos API
 * Adheridos API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DireccionAltaPayloadDTO } from './direccionAltaPayloadDTO';
import { IdEntityDTO } from './idEntityDTO';
import { ContactoAltaPayloadDTO } from './contactoAltaPayloadDTO';


export interface AdheridoPayloadDTO { 
    razonSocial: string;
    tipoDocumento: AdheridoPayloadDTO.TipoDocumentoEnum;
    codigoDocumento: string;
    scrapOrigen?: IdEntityDTO;
    direccion: DireccionAltaPayloadDTO;
    contacto: ContactoAltaPayloadDTO;
}
export namespace AdheridoPayloadDTO {
    export type TipoDocumentoEnum = 'NIF' | 'DNI' | 'NIE';
    export const TipoDocumentoEnum = {
        Nif: 'NIF' as TipoDocumentoEnum,
        Dni: 'DNI' as TipoDocumentoEnum,
        Nie: 'NIE' as TipoDocumentoEnum
    };
}


